import { graphqlClient } from '../graphqlClient';

const SETTLEMENT_FIELDS = `
  id
  merchant_id
  merchant_code
  period_start
  period_end
  total_deposits
  total_withdrawals
  total_fees
  net_amount
  currency
  status
  notes
  processed_at
  createdAt
  updatedAt
  merchant {
    id
    name
    code
  }
`;

export const getSettlements = async ({
  page = 1,
  limit = 50,
  search,
  filters,
  merchantIds,
} = {}) => {
  const query = `
    query GetSettlements(
      $page: Int
      $limit: Int
      $search: String
      $filters: SettlementFilterInput
      $merchants: [String]
    ) {
      getSettlements(
        page: $page
        limit: $limit
        search: $search
        filters: $filters
        merchants: $merchants
      ) {
        data {
          ${SETTLEMENT_FIELDS}
        }
        total
        totalPages
        page
        limit
      }
    }
  `;

  const result = await graphqlClient.query(query, {
    page,
    limit,
    search: search || undefined,
    filters: filters || undefined,
    merchants: merchantIds || undefined,
  });

  return result.getSettlements;
};

export const getSettlementById = async (id) => {
  const query = `
    query GetSettlementById($id: String!) {
      getSettlementById(id: $id) {
        ${SETTLEMENT_FIELDS}
      }
    }
  `;

  const result = await graphqlClient.query(query, { id });
  return result.getSettlementById;
};

export const getMerchantSettlements = async ({
  page = 1,
  limit = 50,
  search,
  filters,
} = {}) => {
  const query = `
    query GetMerchantSettlements(
      $page: Int
      $limit: Int
      $search: String
      $filters: SettlementFilterInput
    ) {
      getMerchantSettlements(
        page: $page
        limit: $limit
        search: $search
        filters: $filters
      ) {
        data {
          ${SETTLEMENT_FIELDS}
        }
        total
        totalPages
        page
        limit
      }
    }
  `;

  const result = await graphqlClient.query(query, {
    page,
    limit,
    search: search || undefined,
    filters: filters || undefined,
  });

  return result.getMerchantSettlements;
};

export const getResellerSettlements = async ({
  page = 1,
  limit = 50,
  search,
  filters,
} = {}) => {
  const query = `
    query GetResellerSettlements(
      $page: Int
      $limit: Int
      $search: String
      $filters: SettlementFilterInput
    ) {
      getResellerSettlements(
        page: $page
        limit: $limit
        search: $search
        filters: $filters
      ) {
        data {
          ${SETTLEMENT_FIELDS}
        }
        total
        totalPages
        page
        limit
      }
    }
  `;

  const result = await graphqlClient.query(query, {
    page,
    limit,
    search: search || undefined,
    filters: filters || undefined,
  });

  return result.getResellerSettlements;
};


export const createSettlement = async (input) => {
  const mutation = `
    mutation CreateSettlement($input: CreateSettlementInput!) {
      createSettlement(input: $input) {
        ${SETTLEMENT_FIELDS}
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { input });
  return result.createSettlement;
};

export const updateSettlement = async (id, input) => {
  const mutation = `
    mutation UpdateSettlement($id: String!, $input: UpdateSettlementInput!) {
      updateSettlement(id: $id, input: $input) {
        ${SETTLEMENT_FIELDS}
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { id, input });
  return result.updateSettlement;
};

export const processSettlement = async (id) => {
  const mutation = `
    mutation ProcessSettlement($id: String!) {
      processSettlement(id: $id) {
        ${SETTLEMENT_FIELDS}
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { id });
  return result.processSettlement;
};

export const completeSettlement = async (id) => {
  const mutation = `
    mutation CompleteSettlement($id: String!) {
      completeSettlement(id: $id) {
        ${SETTLEMENT_FIELDS}
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { id });
  return result.completeSettlement;
};

export const deleteSettlement = async (id) => {
  const mutation = `
    mutation DeleteSettlement($id: String!) {
      deleteSettlement(id: $id)
    }
  `;

  const result = await graphqlClient.mutate(mutation, { id });
  return result.deleteSettlement;
};
